import { formatBRLCompacto, formatNumero } from '@/lib/format';

// Pedidos e valores por vendedor no período (Matheus, 2026-10-13). Cada linha vem do servidor com a mesma conta do
// topo (painel_service.resumo): gerados = pagos + em aberto + cancelados, os reprovados estão dentro de em aberto e
// o vendido não conta os cancelados, então a linha de total bate com os números do topo.
const CONTAGENS = [
  ['total', 'Gerados'], ['pagos', 'Pagos'], ['abertos', 'Em aberto'], ['reprovados', 'Reprovados'],
  ['cancelados', 'Cancelados'],
];
const VALORES = [['valor_total', 'Vendido'], ['valor_pago', 'Recebido'], ['valor_aberto', 'A receber']];

const somar = (linhas) => Object.fromEntries(
  [...CONTAGENS, ...VALORES].map(([campo]) => [campo, linhas.reduce((s, v) => s + (Number(v[campo]) || 0), 0)]),
);

// Cor só para estado: reprovado em vermelho, zero e cancelado no cinza de legenda (gray-400 não passa no contraste).
const tom = (campo, n) => {
  if (!n || campo === 'cancelados') return 'text-gray-500';
  if (campo === 'reprovados') return 'text-red-600 dark:text-red-400';
  return '';
};

// A primeira coluna de valor abre um separador; a última fecha a margem da folha.
const celulaValor = (i) => `py-2.5 ${i === 0 ? 'border-l border-border pl-4' : 'pl-2'} ${i === VALORES.length - 1 ? 'pr-5' : 'pr-2'}`;

// Pedido sem vendedor (sem dono no cadastro e sem nome gravado) chega com nome nulo, numa linha própria no fim.
const Linha = ({ v, total = false }) => (
  <tr className={`border-t border-border ${total ? 'bg-gray-50 font-medium dark:bg-white/5' : ''}`}>
    <td className="max-w-[220px] truncate py-2.5 pl-5 pr-3 text-left font-medium" title={total ? undefined : v.nome}>
      {total ? 'Total' : v.nome ?? 'Sem vendedor'}
    </td>
    {CONTAGENS.map(([campo]) => (
      <td key={campo} className={`px-2 py-2.5 ${tom(campo, v[campo])}`}>{formatNumero(v[campo])}</td>
    ))}
    {VALORES.map(([campo], i) => <td key={campo} className={celulaValor(i)}>{formatBRLCompacto(v[campo])}</td>)}
  </tr>
);

const TabelaVendedores = ({ vendedores }) => {
  if (!vendedores.length) return <p className="px-5 py-10 text-sm text-gray-500">Nenhuma venda no período.</p>;
  return (
    <div className="overflow-x-auto">
      <table className="w-full min-w-[720px] whitespace-nowrap text-right text-[13px] tabular-nums" data-testid="tabela-vendedores">
        <thead className="text-[12px] text-gray-500">
          <tr>
            <th className="py-2 pl-5 pr-3 text-left font-normal">Vendedor</th>
            {CONTAGENS.map(([campo, rotulo]) => <th key={campo} className="px-2 py-2 font-normal">{rotulo}</th>)}
            {VALORES.map(([campo, rotulo], i) => (
              <th key={campo} className={`font-normal ${celulaValor(i)}`}>{rotulo}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {vendedores.map((v) => <Linha key={v.nome ?? ''} v={v} />)}
          {vendedores.length > 1 && <Linha v={somar(vendedores)} total />}
        </tbody>
      </table>
    </div>
  );
};

export default TabelaVendedores;
